import { React, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";

function SkillCreate(props) {
  const { updateTable, setUpdateTable } = props;
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [skillName, setSkillName] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSkillCreate = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("skillName", skillName);
    axios.post("/company/createSkill", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setSkillName("");
  };

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="SkillCreate-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Create Skill
        </DialogTitle>
        <div className="SkillCreate-modalContainer flex flex-col w-fit mb-4">
          <div className="SkillCreate-skillContainer flex flex-col w-96 mx-auto mb-2">
            <div className="SkillCreate-skill text-lg font-brand-primary">
              Skill *
            </div>
            <CreateValidateTextField
              placeholder="Python"
              pattern="(?=.*\w).+"
              value={skillName}
              setter={setSkillName}
              errorMessage={"Invalid Skill."}
              required={true}
            />
          </div>
          <div className="SkillCreate-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleSkillCreate}
            >
              Create Skill
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenCreateDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="SkillCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="SkillCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Skill
      </button>
    </div>
  );
}

SkillCreate.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
};

SkillCreate.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
};

export default SkillCreate;
